enum UserStatus {
	ACTIVE = "active",
	INACTIVE = "inactive",
	PENDING = "pending",
	DELETED = "deleted",
	BLOCKED = "blocked",
}

const displayNames = {
	[UserStatus.ACTIVE]: "Active",
	[UserStatus.INACTIVE]: "Inactive",
	[UserStatus.PENDING]: "Pending",
	[UserStatus.DELETED]: "Deleted",
	[UserStatus.BLOCKED]: "Blocked",
};

const colors = {
	[UserStatus.ACTIVE]: "green",
	[UserStatus.INACTIVE]: "red",
	[UserStatus.PENDING]: "magenta",
	[UserStatus.DELETED]: "red",
	[UserStatus.BLOCKED]: "red",
};

const messages = {
	[UserStatus.ACTIVE]: "",
	[UserStatus.INACTIVE]: "Your account has been inactivated by an admin.",
	[UserStatus.PENDING]: "Your account is pending for approval.",
	[UserStatus.DELETED]: "Your account has been deleted by an admin.",
	[UserStatus.BLOCKED]: "Your account has been blocked by an admin.",
};

const optionsUserStatus = [
	{ label: displayNames[UserStatus.ACTIVE], value: UserStatus.ACTIVE },
	{ label: displayNames[UserStatus.INACTIVE], value: UserStatus.INACTIVE },
	{ label: displayNames[UserStatus.PENDING], value: UserStatus.PENDING },
	{ label: displayNames[UserStatus.DELETED], value: UserStatus.DELETED },
	{ label: displayNames[UserStatus.BLOCKED], value: UserStatus.BLOCKED },
];

const displayUserStatus = (status: UserStatus) => displayNames[status];

const colorUserStatus = (status: UserStatus) => colors[status];

const messageUserStatus = (status: UserStatus) => messages[status];

export {
	UserStatus,
	displayUserStatus,
	colorUserStatus,
	messageUserStatus,
	optionsUserStatus,
};
